import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ReactiveDialogContentComponent } from '@app/shared/components/dialog/reactive-dialog/base/reactive-dialog-content/reactive-dialog-content.component';
import { AbstractReactiveDialogComponent } from '../reactive-dialog/base/abstract-reactive-dialog-component';

@Component({
  selector: 'app-gsm-edit-checklist-dialog',
  templateUrl: './gsm-edit-checklist-dialog.component.html',
  styleUrls: ['./gsm-edit-checklist-dialog.component.scss'],
  standalone: true,
  imports: [
    ReactiveDialogContentComponent,
    MatIcon
  ]
})
export class GsmEditChecklistDialogComponent extends AbstractReactiveDialogComponent<string, undefined> {
}
